import environment from '../../utils/src/generated/environment';
import { extend } from './utils/objects';
import * as PropertyHandling from './BasePrototype/PropertyHandling';
import * as EventHandling from './BasePrototype/EventHandling';
import * as FunctionHandling from './BasePrototype/FunctionHandling';
import * as LifecycleHandling from './BasePrototype/LifecycleHandling';
import * as RegionHandling from './BasePrototype/RegionHandling';
import * as RenderHandling from './BasePrototype/RenderHandling';
import * as ElementQueriesHandling from './BasePrototype/ElementQueriesHandling';
import * as EmbeddedComponentsHandling from './BasePrototype/EmbeddedComponentsHandling';
var modules = [
    FunctionHandling,
    LifecycleHandling,
    EventHandling,
    RegionHandling,
    PropertyHandling,
    RenderHandling,
    ElementQueriesHandling,
    EmbeddedComponentsHandling
];
/**
 * Extends the base HTMLElement prototype with the callbacks
 * required for each module. Also patches the prototype with
 * custom element support if needed.
 * @abstract
 * @return {HTMLElement}
 */
function createBasePrototype() {
    var basePrototype = {};
    for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
        var module = modules_1[_i];
        if (module.prototypeAdditions) {
            extend(basePrototype, module.prototypeAdditions);
        }
    }
    return basePrototype;
}
var basePrototype = createBasePrototype();
/**
 * Creates a component from a given definition.
 * Expects a JSON defintion, which covers:
 * Its additions to the base-callbacks, its properties, its regions,
 * its render method, and its functions.
 * @abstract
 * @params {Object} definition - Component definition
 * @returns {HTMLElement} CustomPrototype for given component-definition
 */
export function createComponentPrototype(componentName, definition) {
    // Extend boilerplate prototype > create component prototype
    var customPrototype = Object.create(basePrototype);
    customPrototype.__componentName = componentName;
    customPrototype.__componentVersion = environment.PACKAGE_VERSION;
    for (var _i = 0, modules_2 = modules; _i < modules_2.length; _i++) {
        var module = modules_2[_i];
        if (module.extendComponent) {
            module.extendComponent(customPrototype, definition);
        }
    }
    return customPrototype;
}
//# sourceMappingURL=BasePrototype.js.map